export default __webpack_public_path__ + "static/media/logo_fin.cf862593.png";